import { RouteDefinition } from '../shared/navigation/route-definition';
import { RoutePaths } from '../shared/navigation/route-paths';
import { AlwaysShowRouteResolver } from '../shared/navigation/always-show-route-resolver';

export class FinancialServicesRouteDefinition {
  public static getRoutes(): RouteDefinition {
    const financialServicesRouteDefinition = {
      path: RoutePaths.FINANCIAL_SERVICES,
      resolver: AlwaysShowRouteResolver,
      title: 'Financial Services',
      icon: 'icon-cash-fill.svg',
      position: 9
    };

    return financialServicesRouteDefinition;
  }
}
